import { map, Observable, switchMap, tap } from 'rxjs';
import { inject } from '@angular/core';
import { FeatureFlagDto, FeatureFlagsRecord, FeatureFlagsService, FeatureFlagsStorage } from '@feature-flags/infra';
import { setSentryContext } from '@sentry';

export class LoadFeatureFlagsCommandHandler {
  private readonly featureFlagsService: FeatureFlagsService = inject(FeatureFlagsService);
  private readonly featureFlagsStorage: FeatureFlagsStorage = inject(FeatureFlagsStorage);

  loadFlags(): Observable<number> {
    return this.featureFlagsService.getFlags().pipe(
      switchMap((flags: FeatureFlagsRecord) => this.featureFlagsStorage.setState(flags)),
      tap((flags: FeatureFlagsRecord) => this.setSentryFeatureFlags(flags)),
      map((flags: FeatureFlagsRecord) => Object.keys(flags).length)
    );
  }

  private setSentryFeatureFlags(flags: FeatureFlagsRecord): void {
    const flagsWithUsers: Record<string, string | string[]> = Object.entries(flags).reduce(
      (acc: Record<string, string | string[]>, [name, flag]: [string, FeatureFlagDto]) => {
        if (flag.isEnabled) {
          acc[name] = flag.users?.length ? flag.users : 'all';
        }
        return acc;
      },
      {} as Record<string, string[] | string>
    );

    setSentryContext('feature_flags', flagsWithUsers);
  }
}
